import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_REPORT_FIELDS',
  'GET_REPORTS',
  'DOWNLOAD_REPORTS'
);
